import Typography from "../Typography/Typography";

export default function TabBar({ icon, text, isActive, onClick, haveText = true }) {
    const baseClasses = `flex ${haveText ? "w-full" : "w-fit"} items-center gap-[14px] p-3 rounded-[8px] cursor-pointer transition duration-100`;
    const activeClasses = isActive
        ? "bg-gray-200 text-black"
        : "bg-transparent text-gray-600 hover:bg-gray-150 active:scale-[97%]";

    return (
        <div
            className={`${baseClasses} ${activeClasses}`}
            onClick={!isActive ? onClick : undefined}
        >
            {icon}
            <div className={`${haveText ? "opacity-100 block" : "opacity-0 hidden"} transition-all duration-200 ease-in-out overflow-hidden whitespace-nowrap`}>
                <Typography size="16" weight="md" color={isActive ? "black" : "gray-600"}>
                    {text}
                </Typography>
            </div>
        </div>
    );
}